
export default {
    head() {
        return {
            title: 'Find Your Dream Job Faster - Hirey',
            meta: [
                {hid: 'description', name: 'description', content: 'Hirey is the #1 job hiring platform for job seekers in Arizona. Our chat-based hiring platform allows candidates to chat directly with hiring managers, ensuring a quicker hiring process.'}
            ],
          link: [
            {
              rel: 'canonical',
              href: 'https://hirey.com/find-jobs/'
            }
          ]
        }
    },
    data() {
        return {
            scrollTop: 0
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll)
        this.listenerFunction()
    },
    destroyed() {},
    beforeDestroy() {
        this.beforeDestroy()
    },
    methods: {
        handleScroll() {
             Math.floor(document.documentElement.scrollTop || document.body.scrollTop);
        },
        listenerFunction(e) {
            document.addEventListener("scroll", this.handleScroll, true);
        },
        beforeDestroy() {
            document.removeEventListener("scroll", this.listenerFunction);
        },
        goTop(){
    	    this.$refs.scrollBox.scrollTop = 0
        }
    }
}
